<div class="main px-3 py-3">
  <div class="bg-grey">
  </div>
  <div class="page-header">
    <div class="title-container">商品アンマッチ解消</div>
  </div>
  <mat-tab-group class="mat-tab-fill-height" animationDuration="0ms">
    <mat-tab label="参照/ダウンロード" class="label">
      <!-- チェーン選択欄 -->
      <div class="select-chain-container">
        <div class="select-chain-title">
          チェーン：
        </div>
        <mat-form-field floatLabel="never" class="select-chain" appearance="fill">
          <input type="text" placeholder="選択してください" matInput [formControl]="chainListControl"
            [matAutocomplete]="autoComplete">
          <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="autoCompleteDisplay.bind(this)">
            <mat-option *ngFor="let option of filteredChainList | async" [value]="option.chainCd">
              {{option.chainCd}} {{ option.chainName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!-- 参照/ダウンロード -->
      <div class="looker-field">
        <app-tableau-embed #tableauUmmatch [url]="tableauUmmatchedDir" elementId="t-solve-unmatched-goods"
          class="looker-embed">
        </app-tableau-embed>
        <div class="download-button mt-3">
          <button
          mat-raised-button
          color="primary"
          style="margin-right: 3rem"
          (click)="clickedDownLoad()"
        >
          <i class="fa fa-download"></i>
          ダウンロード
        </button>
          <button mat-raised-button color="accent" class="apply-button" (click)="applyOnServicenow()">アップロード申請</button>
          <button mat-raised-button color="primary" (click)="openApplyList()">申請状況確認</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="アップロード" class="label">
      <!-- チェーン選択欄 -->
      <div class="select-chain-container">
        <div class="select-chain-title">
          チェーン：
        </div>
        <mat-form-field floatLabel="never" class="select-chain" appearance="fill">
          <input type="text" placeholder="選択してください" matInput [formControl]="chainListControl"
            [matAutocomplete]="autoComplete">
          <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="autoCompleteDisplay.bind(this)">
            <mat-option *ngFor="let option of filteredChainList | async" [value]="option.chainCd">
              {{option.chainCd}} {{ option.chainName }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!-- アップロード -->
      <div class="upload-field">
        <div class="message-title">
          メッセージ
        </div>
        <div class="upload-control-filed">
          <app-message-field class="message-field"></app-message-field>
          <app-upload-file class="file-drop-field" (fileEvent)="setFile($event)"></app-upload-file>
        </div>
        <div class="upload-button">
          <button mat-raised-button (click)="uploadFile()">
            <i class="fa fa-upload"> アップロード</i>
          </button>
        </div>
        <!-- 非表示ダウンロードリンク -->
        <a #downloadLinkRef style="display: none">非表示リンク</a>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
